import { string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const NotificationsCounterStyled = styled.span`
    align-items: center;
    background: ${MIGRATED_COLORS.red3};
    border-radius: 9.5px;
    color: ${MIGRATED_COLORS.white};
    display: flex;
    font-size: 0.813rem;
    font-weight: bold;
    justify-content: center;
    right: -6px;
    top: -1px;
    position: absolute;
    min-width: 0.8rem;
    height: 0.8rem;
    padding: 8px 5px;
    object-fit: contain;
    ${({ value }) =>
        value > 9
            ? {
                  right: value > 99 ? '-20px' : '-13px',
              }
            : null}
`;

function NotificationsCounter({ value }) {
    return (
        <NotificationsCounterStyled value={value}>
            {value > 99 ? '99+' : value}
        </NotificationsCounterStyled>
    );
}

NotificationsCounter.propTypes = {
    value: string,
};

NotificationsCounter.defaultProps = {
    value: null,
};

export default NotificationsCounter;
